import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { XIcon } from "@heroicons/react/outline";

function isRenewalWithin60Days(trialExpiry) {
  if (!trialExpiry) return false;

  const expiryDate = new Date(trialExpiry);
  if (isNaN(expiryDate.getTime())) return false;

  const now = new Date();
  if (expiryDate <= now) return false;

  const sixtyDaysFromNow = new Date();
  sixtyDaysFromNow.setDate(sixtyDaysFromNow.getDate() + 60);

  return expiryDate <= sixtyDaysFromNow;
}

function getDismissalKey(userId, trialExpiry) {
  return `mobstrRenewalBannerDismissed_${userId}_${trialExpiry}`;
}

export default function GlobalBanner({ userLoggedIn }) {
  const [dismissed, setDismissed] = useState(false);

  const trialExpiry = userLoggedIn?.trialExpiry;
  const showBanner = userLoggedIn && isRenewalWithin60Days(trialExpiry);

  useEffect(() => {
    if (userLoggedIn?.id && trialExpiry) {
      const key = getDismissalKey(userLoggedIn.id, trialExpiry);
      setDismissed(localStorage.getItem(key) === "true");
    } else {
      setDismissed(false);
    }
  }, [userLoggedIn?.id, trialExpiry]);

  const handleDismiss = () => {
    if (userLoggedIn?.id && trialExpiry) {
      const key = getDismissalKey(userLoggedIn.id, trialExpiry);
      localStorage.setItem(key, "true");
      setDismissed(true);
    }
  };

  if (!showBanner || dismissed) return null;

  const formattedDate = format(new Date(trialExpiry), "dd/MM/yyyy");

  return (
    <div className="bg-[#2c4251] text-white" role="alert">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-start justify-between gap-4">
        <p className="text-sm">
          Your renewal date is coming soon on {formattedDate}. Your subscription
          will automatically renew on this date. If you have any questions or
          wish to discuss, please get in touch with us on{" "}
          <a
            href="mailto:support@mobstr.io"
            className="underline hover:text-gray-200"
          >
            support@mobstr.io
          </a>
          . Thank you for your continued custom.
        </p>
        <button
          type="button"
          onClick={handleDismiss}
          className="flex-shrink-0 p-1 rounded hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white"
          aria-label="Dismiss"
        >
          <XIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
